<template>
  <b-modal size="xxl" ref="modal" @hidden="onAfterClose" @show="onShow" v-model="show" modal-class="e-modal forecast-modal" :hide-footer="true" @hide="close" centered>
    <template v-if="asset">
      <template slot="modal-header">
        <div class="title">
          Forecast {{ asset.name }}
        </div>
      </template>
      <template class="buy-crypto-modal-content">
        <em-forecast-header :hint="hint"/>
        <div class="modal-divider"></div>
        <div class="modal-content-container">
          
          <b-row>
            <b-col cols="12" v-if="!isLoading">
              <transition :duration="200" name="fade" mode="out-in">
                <step-create-forecast key="step1" v-if="current === 1" @nextPage="() => this.current = 2" @closeModal="close" />
                <step-lock-tokens key="step2" v-if="current === 2" @nextPage="sendPrediction" @previewPage="() => this.current = 1" @closeModal="close"/>
                <step-finish-message key="step3" v-if="current === 3" @closeModal="close"/>
                <step-already-exists key="step4" :prediction="prediction" v-if="current === 4" @closeModal="close"/>
              </transition>
            </b-col>
          </b-row>
        </div>
      </template>
    </template>
  </b-modal>
</template>

<script>
  import {mapGetters, mapActions, mapMutations} from 'vuex';

  import EmForecastHeader from './header'
  import Services from '@services';

  import StepCreateForecast from "./stepCreateForecast.vue";
  import StepLockTokens from "./stepLockTokens.vue";
  import StepFinishMessage from "./stepFinishMessage.vue";
  import StepAlreadyExists from "./stepAlreadyExists.vue";
  

  export default {
    name: "em-forecast",
    components: {EmForecastHeader, StepCreateForecast, StepLockTokens, StepFinishMessage, StepAlreadyExists},
    data() {
		  return {
        isLoading: true,
        current: 1,
        prediction: null,
      }
    },
    computed: {
		  ...mapGetters('forecast', {
        isShowForecastModal: 'isShowForecastModal',
        forecastData: 'forecastModalData',
        lockedTokens: 'lockedTokens',
        forecastPrediction: 'forecastPrediction'
      }),
      asset() {
        return this.forecastData !== null ? this.forecastData.asset : null;
      },
      hint() {
        return {
          title: 'How forecast is working',
          text: 'Ten years ago a crack commando until was sent to prison by a military count for a crime they didn\'t commit. These men promptly escaped from a maximum security stockade to the Los Angeles underground. Today, still wanted by the goverment, they survive as soldiers of fortune. If you have a problem and no one else can help, and if you can find them, maybe you can hire the A-team.',
          buttonText: 'Got It'
        }
      },
      show: {
        get() {
          return this.isShowForecastModal;
        },
        set(v) {
          this.setShowForecastModal(v);
        }
      },
    },
    methods: {
      ...mapMutations('forecast', ['setShowForecastModal', 'clearForecastModalData']),
      close() {
        this.show = false;
      },
      onAfterClose() {
        this.clearForecastModalData();
      },
      sendPrediction() {
        Services.Forecasts.sendPrediction(this.forecastData.forecast._id, {
          lockedTokens: this.lockedTokens,
          prediction: this.forecastPrediction
        });

        this.current = 3;
      },
      async onShow() {
        const modal = this.$refs.modal;
        const $app = this.$root.$el;

        $app.parentNode.appendChild(modal.$el);

        this.isLoading = true;

        let prediction = await Services.Forecasts.getForecastPrediction(this.forecastData.forecast._id);

        if(prediction !== null) {
          this.prediction = prediction;
          this.current = 4;
        } else {
          this.current = 1;
        }

        this.isLoading = false;        
      },
    },
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modals/forecast/forecast.vue